var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 16.0002C37.4904 16.0002 16 37.4905 16 64.0002C16 90.5098 37.4904 112 64 112C90.5097 112 112 90.5098 112 64.0002C112 37.4905 90.5097 16.0002 64 16.0002ZM5.33337 64.0002C5.33337 31.5995 31.5993 5.3335 64 5.3335C96.4007 5.3335 122.667 31.5995 122.667 64.0002C122.667 96.4009 96.4007 122.667 64 122.667C31.5993 122.667 5.33337 96.4009 5.33337 64.0002Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 58.6665C66.9455 58.6665 69.3333 61.0543 69.3333 63.9998V85.3332C69.3333 88.2787 66.9455 90.6665 64 90.6665C61.0544 90.6665 58.6666 88.2787 58.6666 85.3332V63.9998C58.6666 61.0543 61.0544 58.6665 64 58.6665Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6666 42.6668C58.6666 39.7213 61.0544 37.3335 64 37.3335H64.0533C66.9988 37.3335 69.3866 39.7213 69.3866 42.6668C69.3866 45.6123 66.9988 48.0002 64.0533 48.0002H64C61.0544 48.0002 58.6666 45.6123 58.6666 42.6668Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.e986ebb5875671dcf7b6f2231ce94c47.svg";
export { ForwardRef as ReactComponent };